export default {
  functionKey: "SOMME",
  title: "SOMME",
  group: "Calcul",
  origin: [],
  target: [],
  targetRequired: true,
  multiOrigin: true,
  description: "Additionne plusieurs colonnes pour chaque ligne. Ajoutez les colonnes en Origine.",
  isStarred: false,

  generate(destination, origin, args, isArgumentCol, allOrigins = []) {
    const cols = allOrigins.length > 0 ? allOrigins : (origin ? [origin] : []);
    if (cols.length === 0) return { displayCode: '', safeCode: '' };
    const safeCode = `var _s=0; [${cols.join(',')}].forEach(function(v){_s+=parseFloat(v)||0;}); ${destination}=String(_s);`;
    return { displayCode: safeCode, safeCode };
  }
}
